<template>
  <v-text-field
    v-bind="[fieldProps, $attrs]"
    name="q"
    v-model="model"
    :label="!$attrs.placeholder ? 'Busca' : ''"
    clearable
  ></v-text-field>
</template>

<script>
import { mixin } from "./mixin";

const _data = {
  model: null,
};

export default {
  data: () => ({
    ..._data,
  }),
  watch: {
    $route(v) {
      this.model = v.query.q ? v.query.q : null;
    },
  },
  mounted() {
    if (this.$route.query.q) this.model = this.$route.query.q;
  },
  mixins: [mixin],
};
</script>
